import React, { useEffect, useState } from "react";

function AdminTrainerForm({ trainer, onCancel, onSave }) {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    authUid: "",
    active: true,
  });

  useEffect(() => {
    setForm({
      name: trainer ? trainer.name || "" : "",
      phone: trainer ? trainer.phone || "" : "",
      authUid: trainer ? trainer.authUid || "" : "",
      active: trainer ? trainer.active !== false : true,
    });
  }, [trainer]);

  const updateField = (field) => (event) => {
    setForm({
      ...form,
      [field]: event.target.value,
    });
  };

  const updateActive = (event) => {
    setForm({
      ...form,
      active: event.target.checked,
    });
  };

  const submit = async (event) => {
    event.preventDefault();

    try {
      await onSave(form);
    } catch (e) {
      return;
    }
  };

  const isEdit = !!trainer;
  const hasSavedAuthUid = isEdit && !!trainer.authUid;

  return (
    <form className="admin-panel__form" onSubmit={submit}>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h2 className="h5 mb-0">
          {isEdit ? "Редагування тренера" : "Новий тренер"}
        </h2>
        <button type="button" className="btn btn-link" onClick={onCancel}>
          Назад
        </button>
      </div>

      <div className="form-group">
        <label>Ім'я</label>
        <input
          className="form-control"
          value={form.name}
          onChange={updateField("name")}
          required
        />
      </div>

      <div className="form-group">
        <label>Телефон</label>
        <input
          className="form-control"
          value={form.phone}
          onChange={updateField("phone")}
          readOnly={isEdit}
          required
        />
        {isEdit ? (
          <small className="form-text text-muted">
            Телефон не редагується після створення тренера.
          </small>
        ) : null}
      </div>

      <div className="form-group">
        <label>Firebase Auth UID</label>
        <input
          className="form-control"
          value={form.authUid}
          onChange={updateField("authUid")}
          readOnly={hasSavedAuthUid}
          required
        />
        <small className="form-text text-muted">
          UID користувача з Firebase Authentication. Після збереження не
          редагується.
        </small>
      </div>

      <div className="form-group form-check">
        <input
          type="checkbox"
          id="trainer-active"
          className="form-check-input"
          checked={form.active}
          onChange={updateActive}
        />
        <label className="form-check-label" htmlFor="trainer-active">
          Активний
        </label>
      </div>

      <div className="admin-panel__actions">
        <button type="submit" className="btn btn-primary">
          Зберегти
        </button>
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Скасувати
        </button>
      </div>
    </form>
  );
}

export default AdminTrainerForm;
